#page-body > #content {
	margin-right: 0px;
}

/* HACK overflow: visible prevents @atlaskit/layer dependent components from clipping */
/* will-change: auto prevents breakage of stacking contexts caused by original will-change: transform */
.arj .ReactVirtualized__Grid,
.arj .ReactVirtualized__List,
.arj-export-view .ReactVirtualized__Grid,
.arj-report-view .ReactVirtualized__Grid,
.arj-export-view .ReactVirtualized__List,
.arj-report-view .ReactVirtualized__List {
	overflow: visible !important;
	will-change: auto !important;
}

.arj .ReactVirtualized__Grid__innerScrollContainer,
.arj-export-view .ReactVirtualized__Grid__innerScrollContainer,
.arj-report-view .ReactVirtualized__Grid__innerScrollContainer {
	overflow: visible !important;
}

.releasesTable .ReactVirtualized__Grid,
.releasesTable .ReactVirtualized__List,
.changesTable .ReactVirtualized__Grid,
.changesTable .ReactVirtualized__List {
	overflow-x: hidden !important;
	overflow-y: auto !important;
}
.changesTable .ReactVirtualized__Grid__innerScrollContainer {
	overflow: hidden !important;
}

.changesTable .ReactVirtualized__Table__rowColumn a:focus-visible,
.changesTable .ReactVirtualized__Table__rowColumn button:focus-visible {
	outline-offset: var(--ds-space-negative-025, -2px);
	margin: var(--ds-space-0, 0px) var(--ds-space-negative-025, -2px);
	padding: var(--ds-space-025, 2px);
}
/* /HACK */
